// GAVION rep stats: fiche d'un représentant (/rapports/vendeurs/:id), ouverte depuis le Classement.
export const repStatsFr = {
  title: "Statistiques de %{name}",
  title_fallback: "Statistiques du représentant",
  back: "Retour au classement",
  open_rep: "Voir les statistiques de %{name}",
  forbidden:
    "Seuls les administrateurs peuvent voir le détail des conversations d'un autre représentant.",
  not_found: "Ce représentant est introuvable.",
  error: "Impossible de charger les statistiques.",
  na: "n/d",
  period: {
    label: "Période",
    today: "Aujourd'hui",
    week: "Cette semaine",
    month: "Ce mois-ci",
    last30: "30 derniers jours",
    custom: "Personnalisée",
    from: "Du",
    to: "Au",
    apply: "Appliquer",
    range: "Du %{from} au %{to}",
    previous: "Comparé à la période précédente : du %{from} au %{to}.",
  },
  kpis: {
    title: "Indicateurs",
    dials: "Appels",
    conversations: "Conversations",
    conversation_rate: "Taux de conversation",
    demos: "Démos bookées",
    demo_rate: "Taux démo/conversation",
    deals_won: "Deals gagnés",
    revenue_won: "Revenus gagnés",
    close_rate: "Taux de closing",
    session_time: "Temps de session",
    dials_per_hour: "Appels par heure de session",
    attempts: "Tentatives moyennes avant 1re conversation",
    callbacks: "Rappels respectés",
    callbacks_detail: "%{kept} sur %{due}",
    vs_previous: "%{delta} vs période précédente",
    no_change: "Stable vs période précédente",
    team_avg: "Moyenne équipe : %{value}",
    team_none: "Aucune moyenne d'équipe",
    how: "Comment c'est calculé : %{label}",
    help: {
      dials:
        "Appels sortants du représentant dans la période, sauf « Passer ». Même définition que le Classement.",
      conversations:
        "Appels où une personne a répondu : Parlé – rappeler, Démo réservée, Brochure envoyée ou Pas intéressé. Même définition que le Classement.",
      conversation_rate: "Conversations ÷ appels.",
      demos: "Appels avec le résultat « Démo réservée ».",
      demo_rate: "Démos bookées ÷ conversations.",
      deals_won:
        "Deals non archivés passés à « Gagné » dans la période (date de la vente).",
      revenue_won: "Somme des montants des deals gagnés dans la période.",
      close_rate:
        "Démos bookées dans la période dont l'affaire créée par la démo est aujourd'hui gagnée ÷ démos bookées.",
      session_time:
        "Durée des sessions d'appels dans la période (une session ouverte compte jusqu'à maintenant).",
      dials_per_hour:
        "Appels ÷ heures de session. n/d sous une minute de session.",
      attempts:
        "Pour chaque compagnie dont la toute première conversation (tous représentants confondus) a été faite par ce représentant dans la période : nombre d'appels sur cette compagnie jusqu'à cette conversation incluse. Moyenne par compagnie.",
      callbacks:
        "Rappels promis (« Parlé – rappeler ») dont l'heure tombait dans la période : respectés si le représentant a rappelé la compagnie à ± %{minutes} min de l'heure prévue. Un rappel compte une fois sa fenêtre passée.",
    },
  },
  funnel: {
    title: "Entonnoir",
    detail: "%{rate} de l'étape précédente",
    team: "Moyenne équipe : %{value}",
  },
  trend: {
    title: "Tendance quotidienne",
    aria: "Appels, conversations et démos par jour du %{from} au %{to}",
    table: "Voir les chiffres par jour",
    day: "Jour",
    dials: "Appels",
    conversations: "Conversations",
    demos: "Démos",
  },
  outcomes: {
    title: "Résultats d'appels",
    value: "%{count} (%{share})",
  },
  reasons: {
    title: "Raisons « Pas intéressé »",
    unknown: "Non précisée",
    empty: "Aucun « Pas intéressé » sur la période.",
  },
  best_hours: {
    title: "Meilleures heures",
    hint: "Heure locale de la compagnie, %{days} derniers jours (indépendant de la période choisie, pour avoir assez d'appels).",
    empty: "Pas encore assez d'appels pour une carte des heures.",
  },
  segments: {
    trade: "Par métier",
    region: "Par région",
    none: "Non précisé",
    key_trade: "Métier",
    key_region: "Région",
    dials: "Appels",
    conversation_rate: "Taux de conversation",
    demo_rate: "Taux démo/conversation",
    empty: "Aucun appel sur la période.",
  },
  conversations: {
    title: "Conversations",
    filter: "Résultat",
    all: "Tous les résultats",
    count: "%{smart_count} conversation |||| %{smart_count} conversations",
    date: "Date",
    lead: "Compagnie",
    outcome: "Résultat",
    note: "Note",
    follow_up: "Suivi",
    meeting: "Réunion",
    empty: "Aucune conversation sur la période.",
    no_note: "—",
    more: "Lire la suite",
    less: "Réduire",
    callback: "Rappel le %{date}",
    demo: "Démo le %{date}",
    deal_stage: "Affaire : %{stage}",
    reason: "Raison : %{reason}",
    meeting_link: "Note Granola",
    meeting_page: "Voir la réunion",
    page: "Page %{page} sur %{pages}",
    previous: "Précédent",
    next: "Suivant",
    pagination: "Pagination des conversations",
  },
  demo_seed: {
    button: "Charger des données d'exemple (démo)",
    loading: "Chargement…",
    hint: "Mode démo : ajoute 3 représentants fictifs, leurs appels, sessions, deals et coûts pour explorer les statistiques.",
  },
};
